import { Editor as IEditor } from 'tinymce'

type T = IEditor | undefined

export const useEditor = () => {
  return (window as any)?.tinyMCE?.activeEditor as T
}
